import { Button } from "@mui/material";

import { WebLinkButtonProps } from "./types";

export const WebLinkButton = (props: WebLinkButtonProps) => {
  return (
    <Button href={props.href} rel="noreferrer noopener" target="_blank" className="button">
      {props.text}
    </Button>
  );
};
